import * as React from 'react'

export interface IPassportPhotoViewProps {
    pin: string
}

export default class PassportPhotoView extends React.Component<IPassportPhotoViewProps> {
    render() {

        const { pin } = this.props

        return (
        <div>
            <img 
                src={'https://srsstorageprod2.blob.core.windows.net/passport-photo-container/' 
                    + pin + '.jpg'} 
                alt="" 
                width="100%" 
            />
        </div>)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/PassportPhotoView.tsx